// extracted by mini-css-extract-plugin
export default {"switcher":"switcher_switcher__YVkH0","value":"switcher_value__OiuFK","selected":"switcher_selected__iRhp4"};